import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'how_many_workers_under_age_18_have_worked'

export const dataPointDefinition = {
  retracedId: 'how_many_workers_under_age_18_have_worked',
  name: 'How many workers under the age of 18 have worked at the facility during the assessment timeframe?',
  description:
    'This question applies equally to current workers under the age of 18 AND workers who were 18 during the assessment timeframe, but no longer are 18 or no longer are present. ',
  meta: {
    slcpMeta: {
      key: 'fp-ed-12',
      number: 'FP-WOR-25',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-ed-12', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27660,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
